import styles from './About.module.scss';
import { PolaroidPhoto } from '../PolaroidPhoto/PolaroidPhoto';

export function About() {
  return (
    <section className="section container" id="about" aria-label="About">
      <h2 className="sectionTitle">About</h2>
      <div className={styles.grid}>
        <PolaroidPhoto src="/selfPicture.png" alt="Your Name" caption={`Rapolas "24`} />
        <div className={styles.text}>
          <p>
            Back-end engineer and technical project manager with a focus on <span className={styles.high}>scalable distributed systems</span>,
            <span className={styles.high}> APIs</span>, and <span className={styles.high}>delivery excellence</span>.
          </p>
          <p>
            Experienced in both software engineering and project management, I bridge the gap between technical execution and business strategy. As a project manager, I communicate effectively with stakeholders and lead teams with a positive, results-driven attitude. As a software engineer, I deliver impactful solutions informed by deep business insight.<span className={styles.high}> Problem solving is my passion.</span>
          </p>
        </div>
      </div>
    </section>
  );
}